import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../utils/api';

// Query Keys
export const predictionDemandQueryKeys = {
  all: ['predictionDemands'],
  lists: (id, params) => [...predictionDemandQueryKeys.all, 'list', id, params],
  list: (id, params) => [...predictionDemandQueryKeys.lists(id, params)],
};

// 예측 수요 조회
/**
 * 
 * @param {*} params {
 *   FromDate: date-time,
 *   ToDate: date-time,
 *   DrResourceSysId: string,
 *   AppliedModuleName: string,
 *   AppliedModuleVersion: string,
 *   Page: number,
 *   PageSize: number,
 *   OrderBy: string,
 *   OrderDirection: string,
 * }
 * @returns 
 */
export const usePredictionChargingDemandList = (params = {}, options = {}) => {
  return useQuery({
    queryKey: predictionDemandQueryKeys.list(params),
    queryFn: async () => {
      try {
        const response = await api.get(`/drivecore/predictiondemand/api/PredictionChargingDemand`, { params });
        return response || null;
      } catch (error) {
        console.error('PredictionChargingDemandList API Error:', error);
        return null;
      }
    },
    retry: 1,
    retryDelay: 1000,
    ...options,
  });
};

